import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const CTASection = () => {
  const { t } = useTranslation();
  return (
    <section className="relative overflow-hidden bg-gray-900 py-16 lg:py-20">
      {/* Background Image Overlay */}
      <div className="absolute inset-0">
        <picture>
          <source
            type="image/avif"
            srcSet="/image/random/Surgeons-480w.avif 480w, /image/random/Surgeons-768w.avif 768w, /image/random/Surgeons-1024w.avif 1024w, /image/random/Surgeons-1280w.avif 1280w, /image/random/Surgeons.avif 1920w"
            sizes="100vw"
          />
          <source
            type="image/webp"
            srcSet="/image/random/Surgeons-480w.webp 480w, /image/random/Surgeons-768w.webp 768w, /image/random/Surgeons-1024w.webp 1024w, /image/random/Surgeons-1280w.webp 1280w, /image/random/Surgeons.webp 1920w"
            sizes="100vw"
          />
          <img
            src="/image/random/Surgeons.jpg"
            alt="Surgery team"
            loading="lazy"
            decoding="async"
            width="1200"
            height="600"
            className="h-full w-full object-cover"
          />
        </picture>
        <div className="absolute inset-0 bg-black/60" />
      </div>

      {/* Content */}
      <div className="relative z-10 mx-auto max-w-4xl px-4 text-center sm:px-6 lg:px-8">
        <h2 className="mb-4 text-3xl font-bold text-white md:text-4xl lg:text-5xl">
          {t('cta.title')}
        </h2>
        <p className="mx-auto mb-10 max-w-xl text-sm text-gray-200 md:text-lg">
          {t('cta.subtitle')}
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:items-center sm:gap-4">
          <Link
            to="/auth/register"
            className="w-full rounded-lg bg-[#026CB6] px-6 py-3 text-center text-sm font-semibold text-white transition-all hover:bg-[#025a9c] focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:outline-none sm:w-auto sm:text-base"
          >
            {t('cta.joinButton')}
          </Link>

          <Link
            to="/auth/pricing"
            className="w-full rounded-lg border-2 border-white bg-transparent px-6 py-2.5 text-center text-sm font-semibold text-white transition-all hover:bg-white hover:text-gray-900 focus:ring-2 focus:ring-white focus:ring-offset-2 focus:outline-none sm:w-auto sm:text-base"
          >
            {t('cta.pricingButton')}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
